import React from 'react'
import Timeline from '@mui/lab/Timeline';
import TimelineItem from '@mui/lab/TimelineItem';
import TimelineSeparator from '@mui/lab/TimelineSeparator';
import TimelineConnector from '@mui/lab/TimelineConnector';
import TimelineContent from '@mui/lab/TimelineContent';
import TimelineDot from '@mui/lab/TimelineDot';
import TimelineOppositeContent from '@mui/lab/TimelineOppositeContent';

const Work = () => {
  return (
    <>
      <div className='container'>
        <div className='container blog__page'>
          <Timeline position="alternate">
            {/* lambdatest start */}
            <TimelineItem>
              <TimelineOppositeContent color="text.secondary">April 2025 - Present</TimelineOppositeContent>
              <TimelineSeparator>
                <TimelineDot />
                <TimelineConnector />
              </TimelineSeparator>
              <TimelineContent>
                <div className="work-outer-card">
                  <div className="work-heading">
                    <h3>DevOps Engineer@<a href='https://lambdatest.com/' target='_blank' rel="noreferrer">LambdaTest</a></h3>
                  </div>
                  <div className="work-description-row">
                    <div className="work-description">
                      <p><strong>Cost Optimization:</strong> Optimized Azure cloud infrastructure by identifying and cleaning up unused resources, significantly reducing costs. Automated weekly alerts to track underutilized assets and enforced governance through Azure policies to ensure compliance with security and cost controls.</p>
                    </div>
                    <div className="work-description">
                      <p><strong>Inventory Utilization Monitoring:</strong> Implemented inventory utilization monitoring to track resource usage trends, enabling proactive optimization and improved capacity planning across cloud infrastructure.</p>
                    </div>
                  </div>
                  <div className="work-heading">
                    <h6>Azure Policies, Azure Storage, Azure Container Registry, GitHub Actions, CI/CD</h6>
                  </div>
                </div>
              </TimelineContent>
            </TimelineItem>
            <TimelineItem>
              <TimelineOppositeContent color="text.secondary">June 2023 - March 2025</TimelineOppositeContent>
              <TimelineSeparator>
                <TimelineDot />
                <TimelineConnector />
              </TimelineSeparator>
              <TimelineContent>
                <div className="work-outer-card">
                  <div className="work-heading">
                    <h3>Developer Relations - Technical Writer@<a href='https://lambdatest.com/' target='_blank' rel="noreferrer">LambdaTest</a></h3>
                  </div>
                  <div className="work-description-row">
                    <div className="work-description">
                      <p><strong>Cross-functional Collaboration:</strong> Worked closely with product managers, developers, and QA engineers to develop clear, user-friendly <a href='https://www.lambdatest.com/support/docs/' target='_blank' rel="noreferrer">documentation</a> that effectively communicated complex technical concepts to end-users.</p>
                    </div>
                    <div className="work-description">
                      <p><strong>Content Audits and Continuous Improvement:</strong> Conducted regular audits and updates to ensure documentation stayed current with software updates and customer insights, enhancing user experience and reducing support inquiries.</p>
                    </div>
                  </div>
                  <div className="work-description-row">
                    <div className="work-description">
                      <p><strong>Comprehensive Documentation:</strong> Authored and maintained diverse documentation assets—including user guides, <a href='https://www.lambdatest.com/support/api-doc/' target='_blank' rel="noreferrer">API documentation</a>, <a href='https://www.lambdatest.com/support/docs/hyperexecute-release-notes/' target='_blank' rel="noreferrer">release notes</a>, and <a href='https://www.lambdatest.com/blog/author/amanchopraatg/' target='_blank' rel="noreferrer">knowledge base articles</a>—consistently praised for clarity and precision.</p>
                    </div>
                    <div className="work-description">
                      <p><strong>Developer Engagement:</strong> Created <a href='https://github.com/john190501?tab=repositories' target='_blank' rel="noreferrer">code samples</a>, <a href='https://youtube.com/playlist?list=PLZMWkkQEwOPkTh2Q6WYpExWoQ8yzqjZ1C&si=J3V2NanZ-eif26YN' target='_blank' rel="noreferrer">tutorials</a>, and <a href='https://www.lambdatest.com/blog/author/amanchopraatg/' target='_blank' rel="noreferrer">blog posts</a> to guide developers in integrating our platform, significantly boosting developer engagement and support.</p>
                    </div>
                  </div>
                  <div className="work-heading">
                    <h6>GitHub Actions, Swagger/OpenAPI, Postman, Technical Documentation Writing (Markdown), YAML</h6>
                  </div>
                </div>
              </TimelineContent>
            </TimelineItem>
            {/* lambdatest end */}

            {/* udyamwell start */}
            <TimelineItem>
              <TimelineOppositeContent color="text.secondary">June 2023 - Present</TimelineOppositeContent>
              <TimelineSeparator>
                <TimelineDot />
                <TimelineConnector />
              </TimelineSeparator>
              <TimelineContent>
                <div className="work-outer-card">
                  <div className="work-heading">
                    <h3>Technical Project Manager@<a href='https://www.udyamwell.com/' target='_blank' rel="noreferrer">UdyamWell</a></h3>
                  </div>
                  <div className="work-description-row">
                    <div className="work-description">
                      <p><strong>Cross-functional Team Leadership:</strong> Led a frontend, backend, and content team to deliver a high-performance website with seamless collaboration.</p>
                    </div>
                    <div className="work-description">
                      <p><strong>Azure Cloud Infrastructure & DevOps:</strong> Oversaw cloud infrastructure and implemented DevOps practices on Azure for efficient deployment and ongoing maintenance.</p>
                    </div>
                  </div>
                  <div className="work-description-row">
                    <div className="work-description">
                      <p><strong>User-Centric Design & UX:</strong> Spearheaded website design and user experience to ensure a user-friendly, engaging online presence.</p>
                    </div>
                    <div className="work-description">
                      <p><strong>Efficient Deployment:</strong> Successfully deployed the website on Azure, leveraging automation tools and best practices to optimize performance and scalability.</p>
                    </div>
                  </div>
                  <div className="work-heading">
                    <h6>Azure App Services, and Azure Storage, Azure Container Registry, GitHub Actions, CI/CD, Figma, React.js, Node.js,  MongoDB</h6>
                  </div>
                </div>
              </TimelineContent>
            </TimelineItem>
            {/* udyamwell end */}

            {/* geeksforgeeks start */}
            <TimelineItem>
              <TimelineOppositeContent color="text.secondary">Oct 2022 - Jun 2023</TimelineOppositeContent>
              <TimelineSeparator>
                <TimelineDot />
                <TimelineConnector />
              </TimelineSeparator>
              <TimelineContent>
                <div className="work-outer-card">
                  <div className="work-heading">
                    <h3>Project Coordinator@GeeksforGeeks</h3>
                  </div>
                  <div className="work-description-row">
                    <div className="work-description">
                      <p>Achieved a <strong>22% increase in DevOps content traffic </strong>through strategic enhancements in technical blogs, video content, and project-based articles.</p>
                    </div>
                    <div className="work-description">
                      <p><strong>Project Planning, Team Management, and Stakeholder Communication: </strong>Led project planning, scheduling, and issue resolution while effectively managing a cross-functional project team. Maintained consistent communication with stakeholders to ensure alignment and progress.</p>
                    </div>
                  </div>
                  <div className="work-description-row">
                    <div className="work-description">
                      <p><strong>Talent Acquisition and Content Development Initiatives:</strong> Spearheaded hiring efforts across DevOps, Gate CS, Python, GBlog, and freelance teams, bringing in high-quality talent. Introduced new practices to enhance DevOps content growth and maintain quality standards.</p>
                    </div>
                    <div className="work-description">
                      <p><strong>Content Review, Quality Control, and Knowledge Sharing:</strong>Reviewed and refined articles on DevOps and Cloud tools, ensuring accuracy and quality. Authored in-house articles on various technologies, contributing to the team's knowledge base and content library.</p>
                    </div>
                  </div>
                  <div className="work-heading">
                    <h6>Git and GitHub, AWS, Azure, GCP, Docker, Kubernetest, Google Analytics, SEMrush, Product Management</h6>
                  </div>
                </div>
              </TimelineContent>
            </TimelineItem>
            {/* geeksforgeeks end */}
            
            {/* niit start */}
            <TimelineItem>
              <TimelineOppositeContent color="text.secondary">Nov 2021 - Sep 2023</TimelineOppositeContent>
              <TimelineSeparator>
                <TimelineDot />
                <TimelineConnector />
              </TimelineSeparator>
              <TimelineContent>
                <div className="work-outer-card">
                  <div className="work-heading">
                    <h3>Technical Mentor@National Institute for Industrial Training</h3>
                  </div>
                  <div className="work-description-row">
                    <div className="work-description">
                      <p><strong>Project Course - Full Stack Web Development:</strong> Developed a hands-on, project-driven course covering HTML5, CSS3, JavaScript, PHP, MySQL, and Azure, designed to build foundational full-stack skills.</p>
                    </div>
                    <div className="work-description">
                      <p><strong>Tutorial - Full Stack Web Development and Data Structures & Algorithms with Java:</strong> Created a comprehensive tutorial series, including recorded live sessions and documentation, featuring HTML5, CSS3, JavaScript, PHP, MySQL, Azure, and Java.</p>
                    </div>
                  </div>
                  <div className="work-description-row">
                    <div className="work-description">
                      <p><strong>Leadership and Project Development:</strong> Led the Web Team in designing and delivering multiple projects for the organization, driving impactful outcomes.</p>
                    </div>
                    <div className="work-description">
                      <p><strong>Impact:</strong> Successfully trained 150+ students with a strong 4.65 average course rating, reflecting high engagement and satisfaction.</p>
                    </div>
                  </div>
                  <div className="work-heading">
                    <h6>HTML5, CSS3, JavaScript, PHP, MySQL, Git and GitHub, Azure</h6>
                  </div>
                </div>
              </TimelineContent>
            </TimelineItem>
            {/* niit end */}
          </Timeline>
        </div>  
      </div>
    </>
  )
}

export default Work